export default function Footer() {
  const navLinks = [
    { label: "회사소개", href: "#about" },
    { label: "제공서비스", href: "#services" },
    { label: "진행절차", href: "#process" },
    { label: "시공사례", href: "#portfolio" },
    { label: "FAQ", href: "#faq" },
    { label: "견적요청", href: "#estimate" },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-blue-50 border-t border-blue-100 pt-10 lg:pt-14 pb-6 lg:pb-8">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10 mb-8 lg:mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 lg:gap-3 mb-3 lg:mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/af1a3309-e7cb-4f5c-b986-960b45a850ba.png"
                alt="착한누수 로고"
                className="h-10 lg:h-14 w-auto object-contain rounded-lg"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-zinc-900 text-lg lg:text-xl font-black">착한누수</span>
                <span className="text-blue-500 text-xs font-medium">24시 수도권 누수 전문</span>
              </div>
            </div>
            <p className="text-zinc-500 text-xs lg:text-sm leading-relaxed mb-3 lg:mb-4">
              서울·경기 수도권 전지역 24시간 연중무휴 누수 전문업체.<br />
              10년 이상의 경력과 최신 장비로 정확하고 신속하게 해결합니다.
            </p>
            <a
              href="tel:010-2684-4892"
              className="inline-flex items-center gap-2 text-blue-600 font-bold text-base lg:text-lg cursor-pointer hover:text-blue-500 transition-colors"
            >
              <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center">
                <i className="ri-phone-fill" />
              </span>
              010-2684-4892
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-zinc-800 font-bold text-sm lg:text-base mb-3 lg:mb-5">바로가기</h4>
            <ul className="flex flex-col gap-2 lg:gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-zinc-500 hover:text-blue-500 text-xs lg:text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-zinc-800 font-bold text-sm lg:text-base mb-3 lg:mb-5">연락처 정보</h4>
            <div className="flex flex-col gap-2.5 lg:gap-3">
              <div className="flex items-start gap-2 lg:gap-3">
                <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center text-blue-500 mt-0.5 flex-shrink-0">
                  <i className="ri-phone-fill" />
                </span>
                <div>
                  <div className="text-zinc-800 font-semibold text-xs lg:text-sm">010-2684-4892</div>
                  <div className="text-zinc-400 text-xs">24시간 연중무휴</div>
                </div>
              </div>
              <div className="flex items-start gap-2 lg:gap-3">
                <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center text-blue-500 mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-2-fill" />
                </span>
                <div>
                  <div className="text-zinc-800 font-semibold text-xs lg:text-sm">서울·경기·인천 수도권 전지역</div>
                  <div className="text-zinc-400 text-xs">야간·공휴일 출동 가능</div>
                </div>
              </div>
              <div className="flex items-start gap-2 lg:gap-3">
                <span className="w-4 h-4 lg:w-5 lg:h-5 flex items-center justify-center text-blue-500 mt-0.5 flex-shrink-0">
                  <i className="ri-time-fill" />
                </span>
                <div>
                  <div className="text-zinc-800 font-semibold text-xs lg:text-sm">365일 24시간</div>
                  <div className="text-zinc-400 text-xs">연중무휴 즉시 출동</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-200 pt-5 lg:pt-6 flex flex-col md:flex-row items-center justify-between gap-2 lg:gap-3">
          <p className="text-zinc-400 text-xs text-center md:text-left">
            © 2024 수도권 누수 전문업체. All rights reserved.
          </p>
          <p className="text-zinc-400 text-xs">사업자등록번호 : 000-00-00000</p>
        </div>
      </div>
    </footer>
  );
}
